/****************************************************
 * Module Name:  selectUserModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, Button, Tooltip } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import Select from "react-select";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const SelectUserModal = ({
    show,
    setShow,
    handleSave,
    loading,
    filteredEmployeeData,
    setFilteredEmployeeData
}) => {
    const [showUserDetailModal, setShowUserDetailModal] = useState(false);
    const saveHandler = () => {

        if (handleSave) {
            handleSave(filteredEmployeeData.employee[0].value);
        }
    };

    const handleClose = () => {
        setShow(false);
    };

    return (
        <div>
            {showUserDetailModal ? (
                <UserDetailModal
                    show={true}
                    handleClose={() => setShowUserDetailModal(false)}
                    handleSelect={(selectedOption) => {
                        const selectedCustomers = filteredEmployeeData.employeeOptions.filter(opt =>
                            selectedOption.includes(opt.value)
                        );
                        setFilteredEmployeeData({
                            ...filteredEmployeeData,
                            employee: selectedCustomers,
                        });
                        setShowUserDetailModal(false)
                    }}
                    userids={filteredEmployeeData.employeeOptions.filter(option => option.value !== "*").map(cust => cust.value)}
                    selectedIds={filteredEmployeeData.employee.length !== 0 ? filteredEmployeeData.employee.map(iCustomer => iCustomer.value) : []}
                    usertype={"E"}
                    loading={showUserDetailModal}
                    isMulti={false}
                />
            ) : null}

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                size="lg"
                centered
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Reassign Customer
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box sx={{
                        // display: "flex",
                        gap: "20px",
                        mt: 2,
                        "& .basic-single": {
                            width: "500px"
                        },
                        display: "inline-flex",
                        alignItems: "center",
                    }}>
                        <Form.Label className="mt-2">Assign To Employee</Form.Label>
                        <Select menuPlacement="auto"
                            blurInputOnSelect={false}
                            className="basic-single"
                            classNamePrefix="select"
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            value={filteredEmployeeData.employee}
                            isSearchable={true}
                            name="Employee"
                            menuPortalTarget={document.body}
                            styles={Constants.Styles}
                            options={filteredEmployeeData.employeeOptions}
                            onChange={(selectedOption) => {
                                setFilteredEmployeeData({
                                    ...filteredEmployeeData,
                                    employee: [selectedOption],
                                });
                            }}
                        />
                        <Tooltip title="View More Data">
                            <span style={{ cursor: "pointer" }}>
                                <OpenInNewIcon
                                    fontSize="medium"
                                    color="action"
                                    onClick={() => setShowUserDetailModal(true)}
                                />
                            </span>
                        </Tooltip>
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        onClick={saveHandler}
                        type="Submit"
                        sx={{ mr: 3 }}
                    >
                        Transfer
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        sx={{ mr: 2 }}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SelectUserModal;
